import { render, staticRenderFns } from "./AddNewsfeedPost.vue?vue&type=template&id=5d8dec71&"
import script from "./AddNewsfeedPost.vue?vue&type=script&lang=js&"
export * from "./AddNewsfeedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports